import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const getMemoRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/<OBJECT ENDPOINT>/:id/memos/:memoId',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/<OBJECT ENDPOINT>/:id/memos/:memoId' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};
const getMemosResponse: Json = {
    title: 'RESPONSE',
    json: {
        "id": 42,
        "memo": "This is a memo",
        "username": "admin",
        "dateCreated": "2021-02-26T13:59:53.171-0700"
    }
};
const data: RequestDefinitionData = {
    id: 'get-memo',
    title: 'Get a memo',
    description: 'Retrieves the details of an existing memo. You only need to provide the unique memo ID. Requires the object\'s VIEW access right. Location group restrictions depend on the object type: for sales orders, purchase orders, work orders and manufacture orders, and for transfer orders (checked against both their from and ship-to location groups), read-only access is sufficient and a 403 is returned only when the user has no access at all. Parts, products and vendors have no location group. Returns 404 if the memo is not found.',
    endpoint: {
        verb: 'GET',
        path: '/<OBJECT ENDPOINT>/:id/memos/:memoId',
        tooltip: 'Get a memo',
    },
    attributes: [],
    requestObject: getMemoRequest,
    responseObject: getMemosResponse,
};

export default data;
